import {
  makeTubeComponent,
  tubeComponentType,
} from '@/_models/virtualStaging/Tube/component/Tube.component';

export class DeloreanCTBPipes {
  devices = [];
  waterLevelPipe1: any;
  oilLevelPipe1: any;
  waterLevelPipe2: any;
  oilLevelPipe2: any;
  waterLevelPipe3: any;
  oilLevelPipe3: any;

  animationFrameId: number | null = null;
  targetOilScale1 = 0;
  targetWaterScale1 = 0;
  targetOilPosition1 = 0.2;
  targetOilScale2 = 0;
  targetWaterScale2 = 0;
  targetOilPosition2 = 0.2;
  targetOilScale3 = 0;
  targetWaterScale3 = 0;
  targetOilPosition3 = 0.2;
  animationDuration = 1000;
  animationStartTime = 0;
  isAnimating = false;

  constructor(showcaseTemp, devices) {
    showcaseTemp.showcase.Scene.register(tubeComponentType, makeTubeComponent).then(() => {
      Promise.all([
        // Tank 1 - Water Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.waterLevelPipe1 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.6,
              y: 0.2,
              z: -2.1,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'blue',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
        // Tank 1 - Oil Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.oilLevelPipe1 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.6,
              y: 0.2,
              z: -2.1,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'lightgreen',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
        // Tank 2 - Water Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.waterLevelPipe2 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.6,
              y: 0.2,
              z: 3.5,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'blue',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
        // Tank 2 - Oil Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.oilLevelPipe2 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.6,
              y: 0.2,
              z: 3.5,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'lightgreen',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
        // Tank 3 - Water Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.waterLevelPipe3 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.8,
              y: 0.2,
              z: 9.1,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'blue',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
        // Tank 3 - Oil Level
        showcaseTemp.mpSDK.Scene.createNode().then((node) => {
          this.oilLevelPipe3 = node.addComponent(tubeComponentType, {
            position: {
              x: -11.8,
              y: 0.2,
              z: 9.1,
            },
            rotation: { x: -Math.PI / 2, y: 0, z: 0 },
            visible: true,
            color: 'lightgreen',
            hasTexture: false,
            length: 9.2,
            width: 2.5,
            scale: 1,
          });
          node.start();
        }),
      ]).then(() => {
        if (devices) this.update(devices);
      });
    });
  }

  getValue(externalDeviceId) {
    return this.devices.find((device) => device.externalDeviceId === externalDeviceId)
      .additionalInfo?.Value;
  }

  animate = (timestamp) => {
    if (!this.animationStartTime) {
      this.animationStartTime = timestamp;
    }

    const elapsed = timestamp - this.animationStartTime;
    const progress = Math.min(elapsed / this.animationDuration, 1);

    // Tank 1 animations
    if (this.oilLevelPipe1) {
      const startOilScale = this.oilLevelPipe1.root.scale.y;
      this.oilLevelPipe1.root.scale.y =
        startOilScale + (this.targetOilScale1 - startOilScale) * progress;
    }

    if (this.waterLevelPipe1) {
      const startWaterScale = this.waterLevelPipe1.root.scale.y;
      this.waterLevelPipe1.root.scale.y =
        startWaterScale + (this.targetWaterScale1 - startWaterScale) * progress;
    }

    if (this.oilLevelPipe1) {
      const startOilPosition = this.oilLevelPipe1.root.position.y;
      this.oilLevelPipe1.root.position.y =
        startOilPosition + (this.targetOilPosition1 - startOilPosition) * progress;
    }

    // Tank 2 animations
    if (this.oilLevelPipe2) {
      const startOilScale = this.oilLevelPipe2.root.scale.y;
      this.oilLevelPipe2.root.scale.y =
        startOilScale + (this.targetOilScale2 - startOilScale) * progress;
    }

    if (this.waterLevelPipe2) {
      const startWaterScale = this.waterLevelPipe2.root.scale.y;
      this.waterLevelPipe2.root.scale.y =
        startWaterScale + (this.targetWaterScale2 - startWaterScale) * progress;
    }

    if (this.oilLevelPipe2) {
      const startOilPosition = this.oilLevelPipe2.root.position.y;
      this.oilLevelPipe2.root.position.y =
        startOilPosition + (this.targetOilPosition2 - startOilPosition) * progress;
    }

    // Tank 3 animations
    if (this.oilLevelPipe3) {
      const startOilScale = this.oilLevelPipe3.root.scale.y;
      this.oilLevelPipe3.root.scale.y =
        startOilScale + (this.targetOilScale3 - startOilScale) * progress;
    }

    if (this.waterLevelPipe3) {
      const startWaterScale = this.waterLevelPipe3.root.scale.y;
      this.waterLevelPipe3.root.scale.y =
        startWaterScale + (this.targetWaterScale3 - startWaterScale) * progress;
    }

    if (this.oilLevelPipe3) {
      const startOilPosition = this.oilLevelPipe3.root.position.y;
      this.oilLevelPipe3.root.position.y =
        startOilPosition + (this.targetOilPosition3 - startOilPosition) * progress;
    }

    if (progress < 1) {
      this.animationFrameId = requestAnimationFrame(this.animate);
    } else {
      this.animationFrameId = null;
      this.animationStartTime = 0;
      this.isAnimating = false;
    }
  };

  update(devices) {
    this.devices = devices;
    if (
      !this.oilLevelPipe1 ||
      !this.waterLevelPipe1 ||
      !this.oilLevelPipe2 ||
      !this.waterLevelPipe2 ||
      !this.oilLevelPipe3 ||
      !this.waterLevelPipe3
    )
      return;

    // Tank 1 - Swapped: oil now reads from top level, water from bottom level
    const waterValue1 = this.getValue('Oil Tank 1 Bottom Level');
    const oilValue1 = this.getValue('Oil Tank 1 Top Level');

    if (waterValue1) {
      this.targetWaterScale1 = waterValue1 / 24;
    }

    if (oilValue1) {
      this.targetOilScale1 = oilValue1 / 24 - waterValue1 / 24;
      this.targetOilPosition1 = 0.2 + (waterValue1 / 24) * 9.2;
    }

    // Tank 2 - Same logic with different device IDs
    const waterValue2 = this.getValue('Oil Tank 2 Bottom Level');
    const oilValue2 = this.getValue('Oil Tank 2 Top Level');

    if (waterValue2) {
      this.targetWaterScale2 = waterValue2 / 24;
    }

    if (oilValue2) {
      this.targetOilScale2 = oilValue2 / 24 - waterValue2 / 24;
      this.targetOilPosition2 = 0.2 + (waterValue2 / 24) * 9.2;
    }

    // Tank 3 - Same logic with different device IDs
    const waterValue3 = this.getValue('Oil Tank 3 Bottom Level');
    const oilValue3 = this.getValue('Oil Tank 3 Top Level');

    if (waterValue3) {
      this.targetWaterScale3 = waterValue3 / 24;
    }

    if (oilValue3) {
      this.targetOilScale3 = oilValue3 / 24 - waterValue3 / 24;
      this.targetOilPosition3 = 0.2 + (waterValue3 / 24) * 9.2;
    }

    if (!this.isAnimating) {
      this.isAnimating = true;
      this.animationStartTime = 0;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.animationFrameId = requestAnimationFrame(this.animate);
    }
  }
}
